<template>
  <div
    class="wrapper"
    :style="{
      display: center ? 'flex' : 'block',
      justifyContent: center ? 'center' : null,
    }"
  >
    <div
      class="demo-stand"
      :style="{
        width: width,
        transform: `scale(${scale}) ${
          flipToLeft ? 'rotateY(-10deg)' : 'rotateY(10deg)'
        }`,
      }"
    >
      <slot name="demo-content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "DemoStand",
  props: {
    flipToLeft: {
      type: Boolean,
      required: false,
      default: false,
    },
    width: {
      type: String,
      required: false,
      default: "850px",
    },
    scale: {
      type: Number,
      required: false,
      default: 0.65,
    },
    center: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style scoped>
.wrapper {
  perspective: 1000px;
  backface-visibility: hidden;
  max-height: 800px;
}

@media screen and (max-width: 567px) {
  .wrapper {
    perspective: 0px;
    display: flex;
    justify-content: center;
    max-height: none;
  }
}

.demo-stand {
  overflow: hidden;
  backface-visibility: hidden;
  font-family: "Source Sans Pro", sans-serif;
  position: relative;
  -webkit-font-smoothing: subpixel-antialiased;
  display: flex;
  justify-content: center;
  transform-origin: 25% 10%;
  border-radius: 15px;
  background: #f3f6f8;
  box-shadow: 0px -8px 44px 0px rgba(0, 0, 0, 0.18);
  will-change: transform;
  transition: 0.3s;
  transform: rotateY(10deg) scale(0.65);
  @media screen and (max-width: 1200px) {
    transform-origin: 0% 10%;
  }
  @media screen and (max-width: 992px) {
    max-width: 100%;
    transform: rotateY(0deg) scale(1) !important;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.18);
  }
}
</style>
